import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as R from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { setNewPasswordFromReset, resetAuth } from '../../../actions/auth-api';
import { RegexFields } from '../../../constants/utils/regexFields';

export const PasswordNew = () => {
	const dispatch = useDispatch();
	const auth = useSelector(state => state.auth);
	const passwordForm = useRef();
	const history = useHistory();
	const router = useSelector(state => state.router);
	const [token, setToken] = useState(undefined);
	const [userId, setUserId] = useState(undefined);

	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfPassword, setShowConfPassword] = useState(false);

	const [password, setPassword] = useState({
		newPass: '',
		confPass: ''
	});

	const [passwordsMatch, setPasswordsMatch] = useState(false);
	const [wasValidated, setWasValidated] = useState(false);
	const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });

	useEffect(() => {
		if (!R.isNil(password.newPass)) {
			let hasUpper = !R.isNil(password.newPass.match(RegexFields.hasUpperCase));
			let hasLower = !R.isNil(password.newPass.match(RegexFields.hasLowerCase));
			let hasDigits = !R.isNil(password.newPass.match(RegexFields.hasDigits));
			setPasswordRequirements({ ...passwordRequirements, hasDigits: hasDigits, hasLower: hasLower, hasUpper: hasUpper })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [password]);

	useEffect(() => {
		if (!R.isNil(router.location.query)) {
			let tmpToken = router.location.query.token;
			let tmpUserId = router.location.query.userId;

			if (!R.isNil(tmpToken) && !R.isNil(tmpUserId)) {
				setToken(tmpToken);
				setUserId(tmpUserId);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!R.isNil(password)) {
			if (passwordsMatch === true && password.newPass !== password.confPass) {
				setPasswordsMatch(false);
			}
			else if (passwordsMatch === false && password.newPass === password.confPass) {
				setPasswordsMatch(true);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [password]);

	useEffect(() => {
		if (!R.isNil(auth.resetPasswordComplete) && auth.resetPasswordComplete === true) {
			dispatch(resetAuth());
			history.push("/auth/signin");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [auth])

	function formSubmit(event) {
		event.preventDefault();
		if (passwordForm.current.checkValidity() && passwordsMatch === true && passwordRequirements.hasDigits && passwordRequirements.hasLower && passwordRequirements.hasUpper) {
			if (!R.isNil(token) && !R.isNil(userId)) {
				dispatch(setNewPasswordFromReset(userId, token, password.newPass));
			}
		}
		passwordForm.current.classList.add('was-validated');
		setWasValidated(true);
	}

	return (
		<div className="col order-first order-lg-last h-inherit scroll-default">
			<nav className="nav text-right mb-auto">
				<h1 className="sr-only visually-hidden">Help</h1>
				<span className="small font-weight-bold">Besoin d'aide ? <a className="text-info" href="/faqs">FAQ</a></span>
			</nav>
			<form className="container-xl-base py-2 mb-auto" noValidate ref={passwordForm} onSubmit={(event) => { formSubmit(event); }}>
				<h1 className="h1 text-primary font-weight-bolder mb-6">Réinitialisation du mot de passe</h1>
				<div className="form-group">
					<label className="h6 font-weight-bolder" htmlFor="email">Nouveau mot de passe</label>
					<div className="input-group">
						<input required minLength={8} maxLength={32} type={showNewPassword === false ? "password" : ''} className="form-control" id="password" placeholder="saisissez mot de passe" onInput={
							(event) => {
								event.preventDefault();
								setPassword({ ...password, newPass: event.target.value });
								if (!R.isNil(auth.errorOnResetPassword)) {
									dispatch(resetAuth());
								}
							}
						} />
						<div className="input-group-prepend">
							<div className={"input-group-text border-left-0 rounded-right dropdown"}>
								<i className={"eva o-30 fs-root lh-0 " + (showNewPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showNewPassword" onClick={() => { setShowNewPassword(!showNewPassword); }}></i>
							</div>
						</div>
						<div className={"invalid-feedback"}>
							Invalid or empty field.
                 </div>
					</div>
				</div>
				<div className="form-group">
					<label className="h6 font-weight-bolder" htmlFor="email">Confirmer le mot de passe</label>
					<div className="input-group">
						<input required minLength={8} maxLength={32} type={showConfPassword === false ? "password" : ''} className="form-control" id="password-repeat" placeholder="saisissez mot de passe" onInput={
							(event) => {
								event.preventDefault();
								setPassword({ ...password, confPass: event.target.value });
								if (!R.isNil(auth.errorOnResetPassword)) {
									dispatch(resetAuth());
								}
							}
						} />
						<div className="input-group-prepend">
							<div className={"input-group-text border-left-0 rounded-right dropdown"}>
								<i className={"eva o-30 fs-root lh-0 " + (showConfPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showConfPassword" onClick={() => { setShowConfPassword(!showConfPassword); }}></i>
							</div>
						</div>
						<div className={"invalid-feedback"}>Invalid or empty field.</div>
					</div>
				</div>
				<div className={"invalid-feedback alert-info alert" + (passwordsMatch === false && wasValidated === true ? ' d-block' : '')}>
					Passwords do not match.
                 </div>


				<div className="card alert-info text-body">
					<div className="card-body d-flex align-items-start">
						<i className="eva eva-info text-info mr-2 h3 mt-n1"></i>
						<div className="flex-grow-1">
							<h1 className="small font-weight-bolder text-info text-uppercase">Pour un mot de passe plus sûr</h1>
							<p className="small o-50 lh-copy mb-1">Pour atteindre le niveau de sécurité requis, votre mot de passe doit comporter entre 8 et 32 caractères et inclure au moins 3 des types de caractères suivants:</p>
							<div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasUpper ? '' : ' o-50')}>
								<i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasUpper ? ' text-success' : '')}></i>
								<span>une lettre majuscule (A-Z)</span>
							</div>
							<div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasLower ? '' : ' o-50')}>
								<i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasLower ? ' text-success' : '')}></i>
								<span>une lettre minuscule (a-z)</span>
							</div>
							<div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasDigits ? '' : ' o-50')}>
								<i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasDigits ? ' text-success' : '')}></i>
								<span>un chiffre (0-9)</span>
							</div>
						</div>
					</div>
				</div>
				{
					!R.isNil(auth.errorOnResetPassword) ?
						<div className="invalid-feedback alert-error alert d-block">
							Something went wrong
                 </div>
						: ''
				}
				<input type="submit" hidden={true} />
			</form>
			<footer className="block mt-auto text-left w-100 rounded-inherit">
				<Link to="/auth/password/recover" className="btn btn-faded px-md-gutter mr-3">Retour</Link>
				{/* <Link to="/anticipa/onboard" className="btn btn-info px-md-gutter px-4">Enregistrer</Link> */}
				<button className="btn btn-info px-md-gutter px-4" onClick={(event) => { formSubmit(event); }}>Enregistrer</button>
			</footer>
		</div>
	)
}